import Modal from "@/common/components/Modal"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm, SubmitHandler } from "react-hook-form"
import TextArea from "@/common/components/TextArea"
import { Dispatch, SetStateAction, useState } from "react"
import { releasePosSchema, ReleasePosValidationSchema } from "../../schemas/releasePos.schema"
import { useReleasePos } from "@/features/pos/hooks/useReleasePos"
import { useParams } from "react-router-dom"


interface ReleasePosModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onSuccess?: () => void
  onError?: () => void
}

const ReleasePosModal = ({isOpen, setIsOpen, onSuccess, onError }: ReleasePosModalProps) => {
  const [serverError, setServerError] = useState(false)
  const {id} = useParams()
  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors }
  } = useForm<ReleasePosValidationSchema>({
    resolver: zodResolver(releasePosSchema)
  })

  const {mutate, isPending} = useReleasePos({
    id,
    onSuccess: () => {
      resetForm();
      setServerError(false);
      setIsOpen(false);
      onSuccess?.();
    },
    onError: () => {
      setServerError(true);
      onError?.();
    },
  });

  const onSubmit: SubmitHandler<ReleasePosValidationSchema> = (data) => {
    mutate(data);
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      disabled={isPending}
      showClose
      title="Justificativa para liberação"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Preencha o motivo para liberar o POS"
      footer="Confirmar justificativa e salvar alteração"
      body={(
        <form className="flex flex-col gap-4">
          {serverError && <p className="text-sm text-danger-soft">Ocorreu um erro no servidor, cheque os campos e tente novamente</p>}
          <TextArea
            label="Justificativa"
            placeholder="Escreva aqui sua justificativa"
            errorMessage={errors?.description?.message}
            {...register('description')}
          />
        </form>
      )}
    />
  )
}

export default ReleasePosModal